export default {
  props: {
    news: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      activeTab: 'latest',
    }
  },
  computed: {
    newsType() {
      let types = []
      for (let i in this.news) {
        types.push({
          type: i
        })
      }
      
      return types
    },
    newsList() {
      return this.news
    }
  },
  methods: {
    // 获取当前选中的新闻类型的className
    getTabClass(key, item) {
      let className = 'news-tab__type-' + item.type

      return className + (this.activeTab == item.type ? ' news-tab--active' : '')
    },
    changeTab(key) {
      this.activeTab = key
    },
    viewList() {
      this.$router.push({ name: 'PcList' })
    },
    viewMobileList() {
      this.$router.push({ name: 'MobileList' })
    },
    viewNews(item) {
      this.$router.push({ name: 'PcNews', query: { id: item.id } })
    },
    viewMobileNews(item) {
      this.$router.push({ name: 'MobileNews', query: { id: item.id } })
    },
  },
}